module.exports = __webpack_public_path__ + "static/img/logo_white_icon.4a98c5e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/common/logo_white_icon.png
// module id = 3b2R
// module chunks = 41